<template>
  <div class="loading-box">
    <van-image class="bg-box" :src="mainImage" />
    <div class="logo-footer">
      <van-image fit="contain" :src="logoImage" />
    </div>
    <van-loading type="spinner" size="40px" color="#ffffff" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainImage: require("@/assets/imgs/cert/loading_bg.png"),
      logoImage: require("@/assets/imgs/vechain/img-vechain-tm@2x.png")
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.loading-box {
  position: relative;
  width: 100vw;
  max-width: 750px;
  z-index: 1;
  .title-box {
    position: absolute;
    width: 100%;
    top: 10vh;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 40px;
    color: #ffffff;
    text-align: center;
    z-index: 10;
  }
  .bg-box {
    width: 100vw;
    height: 137vw;
    max-width: 750px;
    max-height: 1027.5px;
    z-index: 5;
  }
  .logo-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 40px;
    text-align: center;
    z-index: 5;
    .van-image {
      width: 70vw;
      height: 10.7vw;
      max-width: 525px;
      max-height: 80.25px;
    }
  }
  .van-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    z-index: 100;
    .van-loading__spinner {
      top: 50%;
    }
  }
}
</style>
